import { getAccessToken } from '@/helpers/auth-helper'

import { ROUTES } from '@/constants/routes'

export default function notFound({ router }) {
    if (!getAccessToken()) {
        return router.push({ name: ROUTES.login })
    }

    return router.push({ name: ROUTES.callLog })
}
